import styled from 'styled-components'

const StyledUserPageView = styled.div`
  height: 100vh;
`

export default StyledUserPageView
